module.exports = __webpack_public_path__ + "img/3-squoll-rapport-synthese-webinaire-mob-md.18e66400.png";